<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 56 56"
  fill="none"
  class="tw-size-full tw-animate-spin"
  aria-hidden="true"
>
  <circle
    cx="28"
    cy="28"
    r="23"
    class="tw-stroke-primary-600"
    pathLength="4"
    stroke-width="5"
    stroke-dasharray="1 3"
    stroke-linecap="round"
  ></circle>
  <circle
    cx="28"
    cy="28"
    r="23"
    class="tw-stroke-primary-600"
    stroke-width="5"
    opacity="0.4"
  ></circle>
</svg>
<span class="tw-sr-only" *ngIf="sr">{{ title }}</span>
